import { Body, Button, Dialog, Spacer } from '@spritz-finance/ui'
import styled, { css } from 'styled-components'
import { InnerLoading } from '../../../../components/InnerLoading'
import { useDeleteSubscription } from '../../utils/useDeleteSubscription'
import { Subscription } from './Bills'

const RemoveAccountContainer = styled.div<{ $removed?: boolean }>`
    display: flex;
    flex-direction: column;
    align-items: center;
    transition: opacity 0.2s ease-out;
    ${({ $removed }) =>
        $removed &&
        css`
            opacity: 0;
        `};
`

const SuccessContainer = styled.div<{ $removed?: boolean }>`
    position: absolute;
    margin: auto;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    opacity: 0;
    transition: opacity 0.2s ease-in;
    ${({ $removed }) =>
        $removed &&
        css`
            opacity: 1;
        `};
`

const RemoveSuccess = ({ removed }: { removed: boolean }) => {
    return (
        <SuccessContainer $removed={removed}>
            <Body.Med size={14}>
                This recurring subscription has been successfully cancelled.
            </Body.Med>
        </SuccessContainer>
    )
}

type DeleteSubscriptionDialogProps = {
    subscription: Subscription | null
    onClose: () => void
}

export const DeleteSubscriptionDialog: React.VFC<DeleteSubscriptionDialogProps> = ({
    onClose,
    subscription,
}) => {
    const { removed, deleteSubscription, loading } = useDeleteSubscription(subscription)

    const handleCloseDialog = () => {
        if (loading) return
        onClose()
    }

    const handleCancelSubscription = async () => {
        if (!subscription) return
        await deleteSubscription()
    }

    return (
        <Dialog open={!!subscription} onClose={handleCloseDialog}>
            <Dialog.Content minWidth={560}>
                <RemoveAccountContainer $removed={removed}>
                    {loading && <InnerLoading />}
                    <Spacer height={16} />
                    <Body.SmBold size={18}>Cancel SMARTPay</Body.SmBold>
                    <Spacer height={16} />
                    <Body.Med size={14} style={{ textAlign: 'center' }}>
                        Are you sure you want to cancel recurring payments for this bill?
                    </Body.Med>
                    <Spacer height={32} />
                    <Button.CTA responsive onClick={handleCancelSubscription} variant="secondary">
                        Cancel SMARTPay
                    </Button.CTA>
                </RemoveAccountContainer>
                <RemoveSuccess removed={removed} />
            </Dialog.Content>
        </Dialog>
    )
}
